export default {
  priority: {
    options: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
    value: 0.5,
  },
  changefreq: {
    options: ['always', 'hourly', 'daily', 'weekly', 'monthly', 'yearly', 'never'],
    value: 'monthly',
  },
};
